import { CheckCircle2, Loader2, XCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent } from '@/components/ui/card';

export function ValidationStatusCard({
  status,
  onDismiss,
}: {
  status: string;
  onDismiss: () => void;
}) {
  const isDone = status !== 'RUNNING' && status !== 'STARTING';
  const isOk = status === 'COMPLETED';
  return (
    <Card>
      <CardContent className="flex items-center justify-between py-3">
        <div className="flex items-center gap-2 text-sm">
          {!isDone && <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />}
          {isDone && isOk && <CheckCircle2 className="h-4 w-4 text-emerald-500" />}
          {isDone && !isOk && <XCircle className="h-4 w-4 text-destructive" />}
          <span>
            {!isDone && 'Validating Instagram session…'}
            {isDone && isOk && 'Instagram session validated.'}
            {isDone && !isOk && `Validation ${status.toLowerCase()}. Check Temporal for details.`}
          </span>
        </div>
        {isDone && (
          <Button variant="ghost" size="sm" onClick={onDismiss}>
            Dismiss
          </Button>
        )}
      </CardContent>
    </Card>
  );
}
